import { useState } from 'react';

export function useToggle(initialValue: boolean): [boolean, () => void] {
  const [value, setValue] = useState(initialValue);

  function toggleValue(): void {
    setValue(!value);
  }

  return [value, toggleValue];
}
